export default __webpack_public_path__ + "static/media/background.cbb5c9d9.mp3";